import { render, staticRenderFns } from "./NajavaIzbor.vue?vue&type=template&id=3efe1ffc&scoped=true"
import script from "./NajavaIzbor.vue?vue&type=script&lang=js"
export * from "./NajavaIzbor.vue?vue&type=script&lang=js"
import style0 from "./NajavaIzbor.vue?vue&type=style&index=0&id=3efe1ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe1ffc",
  null
  
)

export default component.exports